<template>
  <section
    id="contact"
    class="relative mx-auto max-w-7xl px-6 py-16 md:py-24"
  >
    <div class="grid lg:grid-cols-2 gap-10">
      <div>
        <h2
          class="text-3xl md:text-5xl font-semibold tracking-tight text-neutral-900"
        >
          Let's build something thoughtful
        </h2>
        <p class="mt-6 text-neutral-700">
          {{ contactText }}
        </p>
        <div class="mt-8 space-y-3">
          <a
            v-for="(contact, index) in contacts"
            :key="index"
            :href="contact.url"
            class="group flex items-center justify-between rounded-xl bg-white ring-1 ring-neutral-200 p-4 hover:bg-neutral-50 hover:ring-neutral-300 transition"
          >
            <div class="flex items-center gap-3">
              <span
                :class="[
                  'h-10 w-10 rounded-lg flex items-center justify-center',
                  contact.bgColor
                ]"
              >
                <component :is="getIconComponent(contact.icon)" :size="20" :class="contact.iconColor" />
              </span>
              <div>
                <p class="text-neutral-900">{{ contact.label }}</p>
                <p class="text-xs text-neutral-600">{{ contact.type }}</p>
              </div>
            </div>
            <ArrowUpRight
              :size="16"
              class="text-neutral-500 group-hover:text-neutral-700"
            />
          </a>
        </div>
      </div>
      <form
        class="rounded-2xl bg-white ring-1 ring-neutral-200 p-6 md:p-8 shadow-sm"
        @submit.prevent="handleSubmit"
      >
        <div class="grid md:grid-cols-2 gap-4">
          <div>
            <label class="text-sm text-neutral-700">Name</label>
            <input
              v-model="form.name"
              type="text"
              placeholder="Name"
              required
              class="mt-2 w-full rounded-lg bg-white px-4 py-3 text-[15px] outline-none ring-1 ring-neutral-200 focus:ring-2 focus:ring-neutral-300 placeholder:text-neutral-400"
            />
          </div>
          <div>
            <label class="text-sm text-neutral-700">Email</label>
            <input
              v-model="form.email"
              type="email"
              placeholder="example@example.com"
              required
              class="mt-2 w-full rounded-lg bg-white px-4 py-3 text-[15px] outline-none ring-1 ring-neutral-200 focus:ring-2 focus:ring-neutral-300 placeholder:text-neutral-400"
            />
          </div>
          <div class="md:col-span-2">
            <label class="text-sm text-neutral-700">Project</label>
            <input
              v-model="form.project"
              type="text"
              placeholder="Brief description"
              required
              class="mt-2 w-full rounded-lg bg-white px-4 py-3 text-[15px] outline-none ring-1 ring-neutral-200 focus:ring-2 focus:ring-neutral-300 placeholder:text-neutral-400"
            />
          </div>
          <div class="md:col-span-2">
            <label class="text-sm text-neutral-700">Details</label>
            <textarea
              v-model="form.details"
              rows="5"
              placeholder="Goals, scope, timeline..."
              required
              class="mt-2 w-full rounded-lg bg-white px-4 py-3 text-[15px] outline-none ring-1 ring-neutral-200 focus:ring-2 focus:ring-neutral-300 placeholder:text-neutral-400"
            ></textarea>
          </div>
        </div>
        <button
          type="submit"
          class="mt-6 inline-flex items-center gap-2 rounded-lg bg-neutral-900 text-white px-4 py-3 text-[15px] ring-1 ring-neutral-900/10 hover:bg-neutral-800 transition"
        >
          <Send :size="16" />
          Send Inquiry
        </button>
      </form>
    </div>
  </section>
</template>

<script>
import { Mail, Linkedin, Dribbble, ArrowUpRight, Send } from 'lucide-vue-next'
import emailjs from 'emailjs-com'

export default {
  name: 'UIUXContact',
  components: {
    Mail,
    Linkedin,
    Dribbble,
    ArrowUpRight,
    Send
  },
  props: {
    contactText: {
      type: String,
      default: 'Currently open for freelance and collabs. Share a short brief and timeline.'
    },
    contacts: {
      type: Array,
      default: () => [
        {
          label: 'muhammadsaadmeh824@gmail.com',
          type: 'Email',
          url: 'mailto:muhammadsaadmeh824@gmail.com',
          icon: 'Mail',
          iconColor: 'text-emerald-600',
          bgColor: 'bg-emerald-100'
        },
        {
          label: 'LinkedIn',
          type: 'Connect',
          url: 'https://www.linkedin.com/in/muhammad-saad-mehboob-125829247/',
          icon: 'Linkedin',
          iconColor: 'text-sky-600',
          bgColor: 'bg-sky-100'
        },
        {
          label: 'Behance',
          type: 'Portfolio',
          url: 'https://www.behance.net/gallery/224061971/Portfolio',
          icon: 'Dribbble',
          iconColor: 'text-pink-600',
          bgColor: 'bg-pink-100'
        }
      ]
    }
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        project: '',
        details: ''
      }
    }
  },
  methods: {
    getIconComponent(iconName) {
      const iconMap = {
        Mail,
        Linkedin,
        Dribbble
      }
      return iconMap[iconName] || Mail
    },
    handleSubmit() {
      // Map UI/UX form fields to EmailJS template variables
      const templateParams = {
        name: this.form.name,
        email: this.form.email,
        budget: this.form.project || 'Not specified',
        message: `Project: ${this.form.project}\n\nDetails: ${this.form.details}`
      }

      emailjs.send('service_pamxyy4', 'template_yg11hne', templateParams, 'y3LTt-etrHp9cxK4b')
        .then((response) => { // eslint-disable-line no-unused-vars
          alert('Message sent successfully!')
          this.form = { name: '', email: '', project: '', details: '' }
        })
        .catch((error) => {
          alert('Failed to send message. Please try again.')
          console.error(error)
        })
    }
  }
}
</script>

